export default __webpack_public_path__ + "static/media/contact-us.c0791d21.jpg";